export const GET_COMPANY_REQUESET = "get/company/request";
export const GET_COMPANY_SUCCESS = "get/company/success";
export const GET_COMPANY_FAILURE = "get/company/failure";

export const GET_JOBS_REQUESET = "GET_JOBS_REQUESET";
export const GET_JOBS_SUCCESS = "GET_JOBS_SUCCESS";
export const GET_JOBS_FAILURE = "GET_JOBS_FAILURE";

export const GET_SINGLE_JOBS_REQUESET = "GET_SINGLE_JOBS_REQUESET";
export const GET_SINGLE_JOBS_SUCCESS = "GET_SINGLE_JOBS_SUCCESS";
export const GET_SINGLE_JOBS_FAILURE = "GET_SINGLE_JOBS_FAILURE";
